import type { TransactionStatus, PaymentResultStatus, PaymentResult, PaymentMessage } from './types';

const SUCCESS_STATUSES: TransactionStatus[] = ['settlement', 'capture'];
const PENDING_STATUSES: TransactionStatus[] = ['pending', 'challenge'];
const ERROR_STATUSES: TransactionStatus[] = ['deny', 'cancel', 'expire', 'failure'];

export function mapTransactionStatus(status: TransactionStatus): PaymentResultStatus {
  if (SUCCESS_STATUSES.includes(status)) return 'success';
  if (PENDING_STATUSES.includes(status)) return 'pending';
  if (ERROR_STATUSES.includes(status)) return 'error';
  return 'error';
}

export function isValidPaymentMessage(data: unknown): data is PaymentMessage {
  if (typeof data !== 'object' || data === null) return false;
  const msg = data as Record<string, unknown>;
  return typeof msg.transaction_status === 'string';
}

export function createPaymentResult(message: PaymentMessage): PaymentResult {
  const transactionStatus = message.transaction_status;
  return {
    transactionStatus,
    status: mapTransactionStatus(transactionStatus),
    rawData: message,
  };
}

export function lockBodyScroll(): void {
  document.body.style.overflow = 'hidden';
}

export function unlockBodyScroll(): void {
  document.body.style.overflow = '';
}
